import {
  INSULATION_CREDIT_CAP_USD,
  INSULATION_CREDIT_RATE,
  INSULATION_GROSS_USD,
  INSULATION_HVAC_REDUCTION,
} from './assumptions';
import { EnergyLoads, MeasureApplication, SimulationContext } from './types';

export const applyInsulation = (loads: EnergyLoads, _ctx: SimulationContext): MeasureApplication => {
  const keep = 1 - INSULATION_HVAC_REDUCTION;
  const incentiveUsd = Math.min(INSULATION_GROSS_USD * INSULATION_CREDIT_RATE, INSULATION_CREDIT_CAP_USD);

  return {
    loads: {
      ...loads,
      coolingKwh: loads.coolingKwh.map((kwh) => kwh * keep),
      fossilHeatUsd: loads.fossilHeatUsd.map((usd) => usd * keep),
      heatingKwh: loads.heatingKwh.map((kwh) => kwh * keep),
    },
    measureCost: {
      grossUsd: INSULATION_GROSS_USD,
      incentiveUsd,
      measure: 'INSULATION',
      netUsd: INSULATION_GROSS_USD - incentiveUsd,
    },
  };
};
